import { get } from '../utils/APIClient';

const unwrapAssignments = (result) => {
  if (Array.isArray(result)) return result;
  if (Array.isArray(result?.data)) return result.data;
  if (Array.isArray(result?.assignments)) return result.assignments;
  if (Array.isArray(result?.studentAssignments)) return result.studentAssignments;
  if (Array.isArray(result?.results)) return result.results;
  if (Array.isArray(result?.items)) return result.items;
  return [];
};

/**
 * Offline / scanned marksheet assignments with an evaluated PDF.
 * Endpoint: GET student-assignments/getStudentOfflineAssignments
 */
export const getStudentOfflineAssignments = async ({ token }) => {
  const result = await get({ url: 'student-assignments/getStudentOfflineAssignments', token });
  return unwrapAssignments(result);
};

/**
 * In-app (online) assignments for the logged-in student.
 * Endpoint: GET student-assignments/getStudentOnlineAssignments
 */
export const getStudentOnlineAssignments = async ({ token }) => {
  const result = await get({ url: 'student-assignments/getStudentOnlineAssignments', token });
  return unwrapAssignments(result);
};
